export const saveData = (data) => ({
  type: 'SAVE_DATA',
  payload: data,
});

export const clearAndSaveData = (data) => ({
  type: 'UPDATE_DATA',
  payload: data,
});
